// The statuses the store list can be filtered by: the three a store settles in and the retention
// policy acts on. In-flight statuses (CREATING, DEACTIVATING...) and commands are left out, per QA on
// PDECOM-6293. Intersected with the service enum, so a status the service retires drops out on its own.
const FILTERABLE = ['FAILED', 'LIVE', 'DEACTIVATED'];

const filterStatuses = (statusTypes) => FILTERABLE.filter((status) => statusTypes.includes(status));

export const isFilterable = (status) => FILTERABLE.includes(status);

export default filterStatuses;
